import React, { useState } from 'react';
import { Input } from '../components/ui/Input';
import { Button } from '../components/ui/Button';
import { InstagramIcon, FacebookIcon } from 'lucide-react';
export function ContactSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    serviceType: '',
    message: ''
  });
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Form submission logic would go here
    console.log('Form submitted:', formData);
    alert('Thank you for your inquiry! We will contact you shortly.');
  };
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section id="contact" className="py-16 md:py-24 bg-white" data-id="element-80">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-81">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-24" data-id="element-82">
          {/* Left: Contact Form */}
          <div className="w-full lg:w-1/2 bg-light-gray p-6 md:p-10 rounded-xl shadow-sm" data-id="element-83">
            <h3 className="font-heading text-2xl font-bold italic text-navy mb-6" data-id="element-84">
              Request an Estimate
            </h3>
            <form onSubmit={handleSubmit} className="space-y-5" data-id="element-85">
              <Input label="Full Name" name="name" placeholder="John Doe" required value={formData.name} onChange={handleChange} data-id="element-86" />

              <div className="grid grid-cols-1 md:grid-cols-2 gap-5" data-id="element-87">
                <Input label="Email Address" name="email" type="email" placeholder="john@example.com" required value={formData.email} onChange={handleChange} data-id="element-88" />
                <Input label="Phone Number" name="phone" type="tel" placeholder="(602) 555-0123" required value={formData.phone} onChange={handleChange} data-id="element-89" />
              </div>

              <div className="w-full flex flex-col gap-1.5" data-id="element-90">
                <label htmlFor="serviceType" className="text-sm font-medium text-navy" data-id="element-91">
                  Service Type
                </label>
                <select id="serviceType" name="serviceType" required className="flex min-h-[44px] w-full rounded-md border border-silver bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red focus:border-transparent" value={formData.serviceType} onChange={handleChange} data-id="element-92">
                  <option value="" disabled data-id="element-93">
                    Select a service...
                  </option>
                  <option value="Residential Carpet" data-id="element-94">Residential Carpet</option>
                  <option value="Commercial Carpet" data-id="element-95">Commercial Carpet</option>
                  <option value="Tile & Grout" data-id="element-96">Tile & Grout</option>
                  <option value="Other" data-id="element-97">Other</option>
                </select>
              </div>

              <div className="w-full flex flex-col gap-1.5" data-id="element-98">
                <label htmlFor="message" className="text-sm font-medium text-navy" data-id="element-99">
                  Message / Details
                </label>
                <textarea id="message" name="message" rows={4} className="flex w-full rounded-md border border-silver bg-white px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red focus:border-transparent resize-y" placeholder="Tell us about the areas you need cleaned..." value={formData.message} onChange={handleChange} data-id="element-100" />
              </div>

              <Button type="submit" variant="primary" size="lg" fullWidth className="mt-2" data-id="element-101">
                Submit Request
              </Button>
            </form>
          </div>

          {/* Right: Contact Info */}
          <div className="w-full lg:w-1/2 flex flex-col justify-center" data-id="element-102">
            <h2 className="font-heading text-4xl md:text-5xl font-bold italic text-navy mb-6" data-id="element-103">
              Ready for Cleaner Floors?
            </h2>

            <div className="mb-8" data-id="element-104">
              <p className="text-silver text-lg mb-2" data-id="element-105">Call or text today!</p>
              <a href="tel:6029351141" className="text-4xl md:text-5xl font-bold text-red hover:text-red-hover transition-colors block mb-6" data-id="element-106">
                (602) 935-1141
              </a>
              <Button variant="primary" size="lg" className="w-full sm:w-auto" data-id="element-107">
                Schedule Appointment
              </Button>
            </div>

            <div className="space-y-6 border-t border-silver/30 pt-8" data-id="element-108">
              <div data-id="element-109">
                <h4 className="font-heading font-bold italic text-navy text-lg mb-1" data-id="element-110">
                  Business Hours
                </h4>
                <p className="text-silver" data-id="element-111">
                  Monday - Saturday: 8:00 AM - 6:00 PM
                </p>
                <p className="text-red font-semibold mt-1" data-id="element-112">
                  ✓ Same-week availability
                </p>
              </div>

              <div data-id="element-113">
                <h4 className="font-heading font-bold italic text-navy text-lg mb-3" data-id="element-114">
                  Connect With Us
                </h4>
                <div className="flex gap-4" data-id="element-115">
                  <a href="#" className="bg-light-gray p-3 rounded-full text-navy hover:bg-red hover:text-white transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Instagram" data-id="element-116">
                    <InstagramIcon size={20} data-id="element-117" />
                  </a>
                  <a href="#" className="bg-light-gray p-3 rounded-full text-navy hover:bg-red hover:text-white transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" aria-label="Facebook" data-id="element-118">
                    <FacebookIcon size={20} data-id="element-119" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}